import Multiselect from 'vue-multiselect';
import i18n from '../../locales';
import store from '../../store';
import LogService from '../../services/LogService';
import showAlert from '../../alert/alertHandler';
import showConfirmation from '../../confirmation/confirmationHandler';
import responseCodeManager from '../../utils/responseCodeManager.js';
import axios from 'axios';
import { checkForm, getPopoverData, hidePopover } from '../../utils/formValidator.js';
import Container from 'typedi';
import vehicleEscl from '../../locales/es-CL/vehicle.json';
import vehicleEsmx from '../../locales/es-MX/vehicle.json';
import vehicleEsco from '../../locales/es-CO/vehicle.json';
import vehicleEnus from '../../locales/en-US/vehicle.json';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import moment from 'moment';
import XLSX from 'xlsx';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export default {
  name: 'crud-vehicle-modal',
  props: ['editMode', 'requireMassive', 'vehicle', 'infoDrivers', 'dataVehicleTypeExtra', 'tags', 'groups', 'callback'],
  components: {
    Multiselect,
    VueCtkDateTimePicker,
  },
  data() {
    return {
      checkForm,
      getPopoverData,
      hidePopover,
      dataAccess: null,
      logService: null,
      isMassiveActive: false,
      isCrudBusy: false,
      isCreateMode: false,
      createPreassignationOnConflict: true,
      valueBrand: '',
      valueVehicleTypeExtra: [],
      selectedTags: [],
      drivers: [],
      driverVehicle: [],
      vehicles: [],
      valueFuel: '',
      valueEnable: '',
      dateTecnicalInspectionDue: '',
      dateLegalPermissionDue: '',
      selectedDriver: null,
      dataBrand: [],
      dataEnable: [
        { name: 'Habilitado', bool: true },
        { name: 'Deshabilitado', bool: false },
      ],
      vehicleForm: {
        id: null,
        name: '',
        brand: '',
        vehicleType: {
          id: 1,
        },
        group: {
          id: 1998,
        },
        maxContinuousTimeDriving: null,
        maxKms: null,
        maxMoney: null,
        maxTime: null,
        maxTimeDriving: null,
        maxVisits: null,
        maxVolume: null,
        maxWeigth: null,
        plate: '',
        chasis: '',
        model: '',
        year: null,
        color: '',
        observation: '',
        status: '',
        fuel: null,
        enabled: true,
        vehicleExtra: {
          id: '',
          fuelEconomy: null,
          tecnicalInspectionDue: '',
          legalPermissionDue: '',
        },
      },
      parameterFields: [
        {
          id: 'name',
          min: null,
          max: 64,
          condition: ['longField'],
        },
        {
          id: 'brand',
          min: null,
          max: null,
          condition: [],
        },
        {
          id: 'vehicleTypeExtra',
          min: null,
          max: 8,
          condition: ['requireField', 'longField'],
        },
        {
          id: 'plate',
          min: null,
          max: 20,
          condition: ['requireField', 'longField'],
        },
        {
          id: 'model',
          min: null,
          max: 255,
          condition: ['longField'],
        },
        {
          id: 'chasis',
          min: null,
          max: 64,
          condition: ['longField'],
        },
        {
          id: 'color',
          min: null,
          max: 50,
          condition: ['longField'],
        },
        {
          id: 'observation',
          min: null,
          max: 255,
          condition: ['longField'],
        },
        {
          id: 'status',
          min: null,
          max: null,
          condition: ['requireField'],
        },
        {
          id: 'enabled',
          min: null,
          max: 255,
          condition: ['requireField'],
        },
      ],
    };
  },
  mounted() {
    this.$root.$on('bv::modal::hide', () => {
      setTimeout(() => {
        this.$destroy(); // cleanup in component
        this.$el.remove();
      }, 300);
    });
    i18n.setLocaleMessage('es-CL', {
      ...i18n.messages['es-CL'],
      vehicle: vehicleEscl,
    });

    i18n.setLocaleMessage('es-MX', {
      ...i18n.messages['es-MX'],
      vehicle: vehicleEsmx,
    });

    i18n.setLocaleMessage('es-CO', {
      ...i18n.messages['es-CO'],
      vehicle: vehicleEsco,
    });

    i18n.setLocaleMessage('en-US', {
      ...i18n.messages['en-US'],
      vehicle: vehicleEnus,
    });
  },
  created() {
    this.dataAccess = store.getters.dataAccess;
    this.logService = Container.get(LogService);
    this.drivers = this.infoDrivers.drivers;
    this.vehicles = store.getters.vehicles;
    this.driverVehicle = this.infoDrivers.driverVehicle;
    this.prepareData();
  },
  methods: {
    t(key, value) {
      return i18n.t(key, value);
    },
    locale() {
      return i18n.locale;
    },
    async getDetailVehicle(id) {
      try {
        const url = `${store.getters.urlAPI}/api/vehicle/${id}`;

        const config = {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
            //'x-api-key': Container.get('apiKey'),
          },
        };
        //SE TRAEN LOS DATOS DE UN CLIENTE
        const { data } = await axios.get(url, config);

        const { data: dataVehicle } = data;
        return dataVehicle;
      } catch (e) {
        console.log(e);
        return {};
      }
    },
    async prepareData() {
      this.isCrudBusy = true;
      await this.getDataBrands();
      if (this.vehicle) {
        const vehicleData = await this.getDetailVehicle(this.vehicle.id);
        this.vehicleForm.id = vehicleData.id;
        this.valueVehicleTypeExtra = vehicleData.vehicleTypeExtra;
        this.vehicleForm.plate = vehicleData.plate;
        this.valueEnable = this.dataEnable.find((item) => item.bool === vehicleData.enabled);
        this.vehicleForm.name = vehicleData.name;
        this.valueBrand = vehicleData.brand;
        this.vehicleForm.model = vehicleData.model;
        this.vehicleForm.chasis = vehicleData.chasis;
        this.vehicleForm.color = vehicleData.color;
        this.dateTecnicalInspectionDue =
          vehicleData.vehicleExtra && vehicleData.vehicleExtra.tecnicalInspectionDue
            ? String(moment(vehicleData.vehicleExtra.tecnicalInspectionDue).format('YYYY-MM-DD'))
            : '';
        this.dateLegalPermissionDue =
          vehicleData.vehicleExtra && vehicleData.vehicleExtra.legalPermissionDue
            ? String(moment(vehicleData.vehicleExtra.legalPermissionDue).format('YYYY-MM-DD'))
            : '';
        this.vehicleForm.observation = vehicleData.observation;
        this.selectedTags = vehicleData.tags ? vehicleData.tags : null;
        this.selectedDriver = this.vehicle?.driver ?? null;
      }
      this.isCrudBusy = false;
    },
    addfile(event) {
      this.file = event.target.files[0];
      let fileReader = new FileReader();
      fileReader.readAsArrayBuffer(this.file);
      fileReader.onload = () => {
        this.arrayBuffer = fileReader.result;
        let data = new Uint8Array(this.arrayBuffer);
        let arr = new Array();
        for (let i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
        let bstr = arr.join('');
        let workbook = XLSX.read(bstr, { type: 'binary', cellDates: true });
        let first_sheet_name = workbook.SheetNames[0];
        let worksheet = workbook.Sheets[first_sheet_name];
        this.rowsExcel = XLSX.utils.sheet_to_json(worksheet, { raw: true });
        this.readFileExcel();
      };
    },
    async readFileExcel() {
      this.rowsExcelTranform = [];
      this.resultValidation = null;
      const listIndexPlate = [];
      const listIndexType = [];
      const listPlateMaxOut = [];
      const listBrandNotExist = [];
      const listEnabledEmpty = [];
      this.prepareFileExcel();
      let idClientTemp = store.getters.clientId;
      let index = 0;
      for (let row of this.rowsExcel) {
        if (row.typeExtra || row.available || row.plate) {
          this.resultValidation = await this.validateDateRequiredExcel(
            row,
            index,
            listIndexPlate,
            listIndexType,
            listPlateMaxOut,
            listBrandNotExist,
            listEnabledEmpty,
          );
          if (this.resultValidation == null) {
            this.missRequiredData = false;
            let vehicleTypeExtra = this.dataVehicleTypeExtra.find((x) => x.name === row.typeExtra);
            let dataGroup = this.groups[0];
            const tagsData = await this.getTagsSelectedExcel(row.tag);

            let brand = null;
            if (row.brand != null) {
              brand = this.dataBrand.find((brand) => row.brand.trim().toLowerCase() === brand.trim().toLowerCase());
              console.log('MArca detectada-', brand, '-marca escrita en excel-', row.brand, '-');
            }
            let vehicle = {
              idClient: idClientTemp,
              name: row.name ? row.name.trim() : '',
              brand: brand != null ? brand : 'Otro',
              vehicleType: {
                id: parseInt(store.getters.idVehicleTypeDefault),
              },
              vehicleTypeExtra: {
                id: vehicleTypeExtra != undefined ? vehicleTypeExtra.id : null,
              },
              group: {
                id: dataGroup != undefined ? dataGroup.id : null,
              },
              plate: row.plate != null ? row.plate.trim() : '',
              tags: tagsData,
              chasis: row.chasis,
              model: row.model != null ? row.model.trim() : '',
              year: null, //Este campo estaba en el excel pero no se estaba capturando ni seteando al json
              color: row.color != null ? row.color.trim() : '',
              observation: row.observation != null ? row.observation.trim() : '',
              status: row.state != null ? row.state.trim() : 'Operativo',
              fuel: row.fuel != null ? row.fuel.trim() : 'diesel', //Este campo estaba en el excel pero no se estaba capturando ni seteando al json
              enabled: true,
              vehicleExtra: {
                id: null,
                fuelEconomy: 0, //Este campo estaba en el excel pero no se estaba capturando ni seteando al json
                tecnicalInspectionDue: row.tecnicalInspectionDue,
                legalPermissionDue: row.dateLegalPermissionDue,
              },
              systemsEnabled: [
                {
                  id: null,
                  idClient: idClientTemp,
                  idSystem: 2,
                  nameSystem: null,
                  nemoSystem: 'LML',
                  enabled: row.available && row.available.toUpperCase() === 'HABILITADO' ? true : false,
                },
              ],
            };
            this.rowsExcelTranform.push(vehicle);
          }
          index += 1;
        }
      }
      if (this.resultValidation != null) {
        this.missRequiredData = true;
        showAlert(this.t('vehicle.crud.title.massCreate'), this.resultValidation.message, 'error');
        this.closeExcel();
      }
    },

    async confirmUploadExcel() {
      if (!this.missRequiredData && this.rowsExcelTranform.length < 1) {
        showAlert('Error', this.t('vehicle.error.emptyFile'), 'error');
        return;
      }
      showConfirmation(
        this.t('vehicle.crud.confirm'),
        this.t('vehicle.crud.bodyConfirm'),
        async () => {
          await this.processExcel();
        },
        this.t('common.cruds.aceptar'),
        this.t('common.cruds.cerrar'),
      );
    },
    async processExcel() {
      this.isCrudBusy = true;

      let result;
      result = await this.saveMassVehicleRequest();
      if (result.status === 'DONE') {
        showAlert(this.t('common.modals.exitoTitulo'), this.t('vehicle.crud.modalSuccessMassive'), 'success');
      } else {
        showAlert(this.t('vehicle.crud.title.massCreate'), result.message, 'error');
      }
      this.isCrudBusy = false;
      this.closeExcel();
      if (result.status === 'DONE') {
        this.callback(null, null, true);
      }
    },
    async saveMassVehicleRequest() {
      let response = null;
      let messageResponse = null;
      if (this.resultValidation) {
        return {
          status: 'Fail',
          message: this.t('vehicle.crud.missingData'),
        };
      }
      try {
        const body = this.rowsExcelTranform;
        this.logService.sendInfo({
          component: 'vehicle',
          message: `saveMassVehicleRequest enviando datos`,
          data: body,
        });
        const ret = await axios.post(`${store.getters.urlAPI}/api/vehicle/request`, body, {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
            'x-api-key': store.getters.clientApiKey,
          },
        });
        response = ret.data;
        console.log('respuesta del servicio vehículos masivo', response);
      } catch (e) {
        this.logService.sendError({
          component: 'vehicle',
          message: `saveMassVehicleRequest fallo ${e.message}`,
        });
        console.log(e);
      }

      let result = {
        status: null,
        message: null,
      };

      if (response != null) {
        let statusResponse = await this.checkStatus(response.executionId);

        await new Promise((r) => setTimeout(r, 3000));
        let counter = 1;
        let failCounter = 0;
        while (statusResponse === 'notReady' && failCounter < 60) {
          statusResponse = await this.checkStatus(response.executionId);
          await new Promise((r) => setTimeout(r, 3000));
          failCounter++;
        }

        if (failCounter === 60) {
          throw new Error('Tiempo de espera excedido');
        }

        while (statusResponse.data.phase !== 'DONE' && statusResponse.data.phase !== 'FAIL' && counter < 60) {
          statusResponse = await this.checkStatus(response.executionId);
          counter++;
          await new Promise((r) => setTimeout(r, 3000));
        }

        if (counter >= 60) {
          result.status = 'FAIL';
          result.message = 'timeout';
          return result;
        }

        if (statusResponse.data.phase === 'DONE') {
          //await this.addVehicleMass(statusResponse.data.vehicleList);
          result.status = 'DONE';
          return result;
        } else {
          messageResponse = statusResponse;
          result.status = 'FAIL';
          result.message =
            messageResponse.data.message != 'Ha ocurrido un error: null'
              ? messageResponse.data.message
              : 'Ha ocurrido un error';
          return result;
        }
      } else {
        result.status = 'FAIL';
        result.message = 'noResponse';
        return result;
      }
    },
    async checkStatus(executionId) {
      try {
        const config = {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
          },
        };
        return await axios.get(`${store.getters.urlAPI}/api/vehicle/checkStatus/${executionId}`, config);
      } catch (e) {
        return 'notReady';
      }
    },
    limitTextTag(count) {
      return `y ${count} atributos más`;
    },
    limitTextType(count) {
      return `y ${count} tipos más`;
    },
    limitTextGroup(count) {
      return `y ${count} grupos más`;
    },
    async prepareFileExcel() {
      const typeExtra = 'Tipo de vehículo (Obligatorio)';
      const plate = 'Placa/patente (Obligatorio)';
      const name = 'Nombre del vehículo';
      const brand = 'Marca';
      const model = 'Modelo';
      const chasis = 'Vin/chasis';
      const color = 'Color';
      const tecnicalInspectionDue = 'Vencimiento de revisión técnica';
      const dateLegalPermissionDue = 'Vencimiento de permiso de circulación';
      const available = 'Habilitado en Last Mile (Obligatorio)';
      const observation = 'Observaciones';
      const tag = 'Atributos';
      for (let row of this.rowsExcel) {
        Object.entries(row).forEach((entry) => {
          const [key, value] = entry;
          if (key.trim() === typeExtra) {
            row.typeExtra = value;
          } else if (key.trim() === plate) {
            row.plate = value;
          } else if (key.trim() === name) {
            row.name = value;
          } else if (key.trim() === brand) {
            row.brand = value;
          } else if (key.trim() === model) {
            row.model = value;
          } else if (key.trim() === chasis) {
            row.chasis = value;
          } else if (key.trim() === color) {
            row.color = value;
          } else if (key.trim() === tecnicalInspectionDue) {
            row.tecnicalInspectionDue = value;
          } else if (key.trim() === dateLegalPermissionDue) {
            row.dateLegalPermissionDue = value;
          } else if (
            key.trim() === available ||
            key.trim() === 'Habilitado/Deshabilitado (Obligatorio)' ||
            key.trim() === 'Habilitado/Deshabilitado' ||
            key.trim() === 'Habilitado'
          ) {
            row.available = value;
          } else if (key.trim() === observation) {
            row.observation = value;
          } else if (key.trim() === tag) {
            row.tag = value;
          } else {
            delete row[key];
          }
        });
      }
    },
    async buildExcelPro() {
      //Metodo que llena el dropdown del excel con datos de tipo de vehículos extra (por cliente)
      this.populateDataVehicleTypeExtraExcel();
      this.populateBrandExcel();
      console.log('PRO PRO PRO VEHICLE');
      console.log(this.tags);
      this.populateTagsExcel();
      const wb = new ExcelJS.Workbook();
      const ws = wb.addWorksheet('Vehiculos');

      const headers = [
        { header: 'Tipo de vehículo (Obligatorio)', key: 'tdv', width: 40 },
        //{ header: 'Grupo (Obligatorio)', key: 'gru', width: 40 },
        { header: 'Placa/patente (Obligatorio)', key: 'pla', width: 30 },
        { header: 'Nombre del vehículo', key: 'ndv', width: 30 },
        { header: 'Marca', key: 'mar', width: 30 },
        { header: 'Modelo', key: 'mod', width: 30 },
        { header: 'Vin/chasis', key: 'cha', width: 30 },
        { header: 'Color', key: 'col', width: 20 },
        { header: 'Vencimiento de revisión técnica', key: 'vrt', width: 20 },
        { header: 'Vencimiento de permiso de circulación', key: 'vpc', width: 20 },
        { header: 'Habilitado en Last Mile (Obligatorio)', key: 'hab', width: 35 },
        { header: 'Observaciones', key: 'obs', width: 40 },
        { header: 'Atributos', key: 'att', width: 25 },
      ];

      ws.columns = headers;

      ws.addRow({
        tdv: this.typeVehicleSelectedExcel,
        //gru: this.groupSelectedExcel,
        pla: '(Ejemplo) AABBCC-123',
        ndv: '(Ejemplo) Vehiculo 1',
        hab: 'Habilitado',
      });
      ws.addRow({
        tdv: this.typeVehicleSelectedExcel,
        //gru: this.groupSelectedExcel,
        pla: '(Ejemplo) AABBCC-124',
        ndv: '(Ejemplo) Vehiculo 2',
        hab: 'Habilitado',
      });

      for (let i = 2; i < 200; i++) {
        if (this.typeVehicleExcel.length > 0) {
          ws.getCell(`A${i}`).dataValidation = {
            type: 'list',
            allowBlank: true,
            formulae: [`"${this.typeVehicleExcel}"`],
          };
        }
        /* ws.getCell(`B${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`"${this.groupsExcel}"`],
        }; */
        if (this.brandsExcel.length > 0) {
          ws.getCell(`D${i}`).dataValidation = {
            type: 'list',
            allowBlank: true,
            formulae: [`"${this.brandsExcel}"`],
          };
        }
        ws.getCell(`J${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: ['"Habilitado,Deshabilitado"'],
        };
        if (this.tagsExcel.length > 0) {
          ws.getCell(`L${i}`).dataValidation = {
            type: 'list',
            allowBlank: true,
            formulae: [`"${this.tagsExcel}"`],
          };
        }
      }

      const buffer = await wb.xlsx.writeBuffer();
      const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      const fileExtension = '.xlsx';
      const blob = new Blob([buffer], { type: fileType });
      saveAs(blob, 'excel_vehiculos_masivo_template' + fileExtension);
    },
    async getTagsSelectedExcel(tagsTemp) {
      if (!tagsTemp) {
        // Maneja null, undefined, y cadenas vacías
        return null;
      }
      const tagsSplitted = tagsTemp.split(',');
      const tagMatched = [];
      for (let tagSplitted of tagsSplitted) {
        for (let tagData of this.tags) {
          if (tagData.name == tagSplitted) {
            tagMatched.push(tagData);
          }
        }
      }
      return tagMatched;
    },
    populateDataVehicleTypeExtraExcel() {
      console.log(this.dataVehicleTypeExtra);
      this.typeVehicleExcel = '';
      for (let i = 0; i < this.dataVehicleTypeExtra.length; i++) {
        if (i == this.dataVehicleTypeExtra.length - 1) {
          this.typeVehicleExcel += this.dataVehicleTypeExtra[i].name.trim();
          this.typeVehicleSelectedExcel = this.dataVehicleTypeExtra[i].name.trim();
          console.log('TYPEVECHICLE', this.typeVehicleExcel);
        } else {
          this.typeVehicleExcel += this.dataVehicleTypeExtra[i].name + ',';
        }
      }
    },
    populateBrandExcel() {
      this.brandsExcel = '';
      for (let i = 0; i < 25; i++) {
        if (i == 24) {
          this.brandsExcel += this.dataBrand[i];
          console.log('BRAND', this.brandsExcel);
        } else {
          this.brandsExcel += this.dataBrand[i] + ',';
        }
      }
    },
    populateTagsExcel() {
      this.tagsExcel = '';
      for (let i = 0; i < this.tags.length; i++) {
        if (i == this.tags.length - 1) {
          this.tagsExcel += this.tags[i].name;
          console.log('TAGECXEL', this.tagsExcel);
        } else {
          this.tagsExcel += this.tags[i].name + ',';
        }
      }
    },
    async getDataBrands() {
      const config = {
        headers: {
          'id-client': store.getters.clientId,
          Authorization: `Bearer ${store.getters.accessToken}`,
          //'x-api-key': Container.get('apiKey'),
        },
      };
      const url = `${store.getters.urlAPI}/api/enum?type=vehicle_brand`;
      try {
        const { data } = await axios.get(url, config);
        const { data: brands } = data;
        this.dataBrand = brands;
      } catch (error) {
        console.log(error);
      }
    },
    showPopover(id) {
      const wrongClass = 'wrong-input';
      this.$root.$emit('bv::show::popover', id);
      const multiselect = document.querySelector(`#${id} .multiselect`);
      if (multiselect) {
        multiselect.classList.add(wrongClass);
        return;
      }
      if (document.getElementById(id)) {
        document.getElementById(id).classList.add(wrongClass);
      }
    },
    async processVehicle() {
      console.log('Esto no esta haciendo ni chota');
      if (!this.isMassiveActive) {
        await this.saveVehicle();
      } else {
        this.confirmUploadExcel();
      }
    },
    async saveVehicle() {
      // Función para limpiar strings
      const clean = (val) => (val ? val.toString().trim() : val);

      // Función para convertir a número si aplica
      const toInt = (val) => (val ? parseInt(val.toString().trim()) : val);

      // Función por defecto si string está vacío
      const defaultIfEmpty = (val, def) => (val && val.length > 0 ? val : def);

      // Construcción del formulario
      let paramsForm = {
        name: clean(this.vehicleForm.name),
        plate: clean(this.vehicleForm.plate),
        model: clean(this.vehicleForm.model),
        year: toInt(this.vehicleForm.year),
        chasis: defaultIfEmpty(clean(this.vehicleForm.chasis), null),
        color: clean(this.vehicleForm.color),
        observation: clean(this.vehicleForm.observation),
        brand: defaultIfEmpty(this.valueBrand, 'Otro'),
        fuel: defaultIfEmpty(this.valueFuel, 'diesel'),
        status: 'Operativo',
        systemsEnabled: [
          {
            idSystem: 2,
            nemoSystem: 'LML',
            enabled: this.valueEnable.bool,
          },
        ],
        enabled: true,
        vehicleType: {
          id: toInt(store.getters.idVehicleTypeDefault),
        },
        vehicleTypeExtra: {
          id: this.valueVehicleTypeExtra?.id,
        },
        group: {
          id: this.groups[0] ? (!isNaN(this.groups[0]) ? this.groups[0] : this.groups[0].id) : null,
        },
        vehicleExtra: {
          fuelEconomy: defaultIfEmpty(this.vehicleForm.vehicleExtra.fuelEconomy, 10),
          tecnicalInspectionDue: this.processDatesUTC(this.dateTecnicalInspectionDue),
          legalPermissionDue: this.processDatesUTC(this.dateLegalPermissionDue),
        },
        tags: Array.isArray(this.selectedTags) ? this.selectedTags : this.selectedTags ? [this.selectedTags] : [],
      };

      // Versión simplificada de `formInput` si lo necesitas por separado
      let formInput = {
        name: paramsForm.name,
        brand: paramsForm.brand,
        vehicleType: paramsForm.vehicleType,
        vehicleTypeExtra: paramsForm.vehicleTypeExtra.id,
        group: paramsForm.group.id,
        plate: paramsForm.plate,
        model: paramsForm.model,
        year: paramsForm.year,
        chasis: paramsForm.chasis,
        color: paramsForm.color,
        observation: paramsForm.observation,
        status: paramsForm.status,
        fuel: paramsForm.fuel,
        fuelEconomy: paramsForm.vehicleExtra.fuelEconomy,
        enabled: this.valueEnable.name,
      };
      let result = await this.validateForm(formInput);
      if (result) {
        await this.validateSelectedDriver(result, paramsForm, 'create');
      }
    },
    async updateVehicle() {
      const clean = (val) => (val ? val.toString().trim() : val);
      const toInt = (val) => (val ? parseInt(val.toString().trim()) : val);
      const defaultIfEmpty = (val, def) => (val && val.length > 0 ? val : def);
      // Construcción del formulario
      let paramsForm = {
        name: clean(this.vehicleForm.name),
        plate: clean(this.vehicleForm.plate),
        model: clean(this.vehicleForm.model),
        year: defaultIfEmpty(toInt(this.vehicleForm.year), 2000),
        chasis: clean(this.vehicleForm.chasis),
        color: clean(this.vehicleForm.color),
        observation: clean(this.vehicleForm.observation),
        brand: defaultIfEmpty(this.valueBrand, 'Otro'),
        fuel: defaultIfEmpty(this.valueFuel, 'diesel'),
        status: 'Operativo',
        systemsEnabled: [
          {
            idSystem: 2,
            nemoSystem: 'LML',
            enabled: this.valueEnable.bool,
          },
        ],
        enabled: true,
        vehicleType: {
          id: this.vehicleForm?.vehicleType?.id ?? toInt(store.getters.idVehicleTypeDefault),
        },
        vehicleTypeExtra: {
          id: this.valueVehicleTypeExtra?.id,
        },
        group: {
          id: this.groups[0] ? (!isNaN(this.groups[0]) ? this.groups[0] : this.groups[0].id) : null,
        },
        vehicleExtra: {
          id: this.vehicleForm.id,
          fuelEconomy: defaultIfEmpty(this.valueFuelEconomy, 10),
          tecnicalInspectionDue: this.processDatesUTC(this.dateTecnicalInspectionDue),
          legalPermissionDue: this.processDatesUTC(this.dateLegalPermissionDue),
        },
        idDepotOrigin: this.selectedDepot?.id ?? null,
        tags: Array.isArray(this.selectedTags) ? this.selectedTags : this.selectedTags ? [this.selectedTags] : [],
      };
      // Si necesitas un `formInput` para otra parte
      let formInput = {
        name: paramsForm.name,
        brand: paramsForm.brand,
        vehicleType: paramsForm.vehicleType.id,
        vehicleTypeExtra: paramsForm.vehicleTypeExtra.id,
        group: paramsForm.group.id,
        plate: paramsForm.plate,
        model: paramsForm.model,
        year: paramsForm.year,
        color: paramsForm.color,
        observation: paramsForm.observation,
        status: paramsForm.status,
        fuel: paramsForm.fuel,
        fuelEconomy: paramsForm.vehicleExtra.fuelEconomy,
        enabled: this.valueEnable.name,
      };
      let result = await this.validateForm(formInput);
      console.log(result);
      if (result) {
        await this.validateSelectedDriver(result, paramsForm, 'update');
      }
    },
    isDate(date) {
      return date instanceof Date;
    },
    processDatesUTC(date) {
      if (this.isDate(date)) {
        return date;
      }
      if (!date || typeof date !== 'string') return null;

      const parts = date.split('-');

      if (parts.length !== 3) return null;

      const [yearStr, monthStr, dayStr] = parts;
      const year = parseInt(yearStr);
      const month = parseInt(monthStr) - 1; // JS months are 0-based
      const day = parseInt(dayStr);

      if (isNaN(year) || isNaN(month) || isNaN(day)) return null;

      // Establece la hora como 13:00 UTC
      return Date.UTC(year, month, day, 13, 0, 0);
    },
    async validateSelectedDriver(result, paramsForm, mode = 'create') {
      try {
        this.createPreassignationOnConflict = true;
        let preAssignmentFinded = false;

        if (this.selectedDriver) {
          this.driverVehicle.forEach((e) => {
            const isSameDriver = this.selectedDriver.id === e.idDriver;
            const isDifferentVehicle = mode !== 'update' || this.vehicleForm.id !== e.idVehicle[0];

            if (isSameDriver && isDifferentVehicle) {
              this.showToast(e, result, paramsForm, mode);
              preAssignmentFinded = true;
            }
          });
        }

        if (!preAssignmentFinded) {
          if (mode === 'update') {
            await this.submitVehicle(result, paramsForm, 'update', this.vehicleForm.id);
          } else {
            await this.submitVehicle(result, paramsForm, 'create', null);
          }
        }
      } catch (e) {
        if (mode === 'update') {
          this.logService.sendError({
            component: 'vehicle',
            message: `validateSelectedDriverForEditVehicle fallo ${e.message}`,
          });
        }
        this.isCrudBusy = false;
        responseCodeManager(e);
      }
    },
    async submitVehicle(result, paramsForm, mode, vehicleId = null) {
      if (!result) return;

      this.isCrudBusy = true;

      const config = {
        headers: {
          'id-client': store.getters.clientId,
          Authorization: `Bearer ${store.getters.accessToken}`,
        },
      };

      const url =
        mode === 'create'
          ? `${store.getters.urlAPI}/api/vehicle/insert`
          : `${store.getters.urlAPI}/api/vehicle/${vehicleId}`;

      try {
        const response =
          mode === 'create' ? await axios.post(url, paramsForm, config) : await axios.patch(url, paramsForm, config);

        const vehicleData = response.data.data;

        if (vehicleData != null && this.createPreassignationOnConflict) {
          //Si estoy en modo edición entonces debo desvincular el conductor al antiguo vehiculo
          if (mode === 'update') {
            const driverTemp = this.driverVehicle.find((e) => vehicleData.id === e.idVehicle[0]);
            if (driverTemp) {
              this.logService.sendInfo({
                component: 'vehicle',
                message: `editVehicle se desvinculara el siguiente conductor`,
                data: driverTemp,
              });
              await this.callback(null, driverTemp.idDriver, false);
            }
          }
          //Si selecciono un conductor entonces se asignara este al vehículo
          if (this.selectedDriver) {
            this.logService.sendInfo({
              component: 'vehicle',
              message: `${mode}Vehicle se vinculara el nuevo conductor`,
              data: this.selectedDriver,
            });
            await this.callback(vehicleData, this.selectedDriver.id, false);
          }
        }

        if (response.status === 200 || response.status === 201) {
          vehicleData.driver = this.selectedDriver;
          this.callback(vehicleData, null, true);
          this.closeModal('crud-vehicle-modal');
          this.isCrudBusy = false;
          showAlert(this.t(`vehicle.modals.title.${mode}`), this.t(`vehicle.modals.body.${mode}`), 'exito');
        } else {
          this.isCrudBusy = false;
          this.closeModal('crud-vehicle-modal');
          showAlert(this.t(`vehicle.modals.title.${mode}`), this.t(`vehicle.modals.error.${mode}`), 'error');
        }

        return vehicleData;
      } catch (e) {
        this.isCrudBusy = false;

        if (e.response?.data) {
          const messageSplitted = e.response.data.split(',');
          let messageResult = '';
          messageSplitted.forEach((text) => {
            if (text.includes('message')) {
              messageResult = text.split('=')[1];
            }
          });
          showAlert('¡Lo sentimos! ', messageResult);
        }

        this.logService.sendError({
          component: 'vehicle',
          message: `${mode}Vehicle fallo en su ${mode === 'create' ? 'creación' : 'edición'} ${e.message}`,
          data: paramsForm,
        });

        return null;
      }
    },
    closeModal(modal) {
      this.$refs[modal].hide();
    },
    async validateForm(formInput) {
      //Inicio de chequeo del form.
      return this.checkForm(this.$root, this.parameterFields, formInput);
    },
    async showToast(vehicleBussy, result, paramsForm, mode) {
      const h = this.$createElement;
      const id = `my-toast-driver-busy-warning`;

      const $closeButton = h(
        'b-button',
        {
          on: {
            click: async () => {
              await this.$bvToast.hide(id);
              this.createPreassignationOnConflict = false;
              return null;
            },
          },
        },
        this.t('vehicle.crud.buttons.cancel'),
      );
      const $acceptButton = h(
        'b-button',
        {
          class: ['float-right'],
          props: { variant: 'success' },
          on: {
            click: async () => {
              await this.$bvToast.hide(id);
              this.createPreassignationOnConflict = true;
              if (mode === 'update') {
                return await this.submitVehicle(result, paramsForm, 'update', this.vehicleForm.id);
              } else {
                return await this.submitVehicle(result, paramsForm, 'create', null);
              }
            },
          },
        },
        this.t('vehicle.crud.buttons.confirm'),
      );
      const vehicleTemp = this.vehicles.find((element) => element.id == vehicleBussy.idVehicle);
      let $vNodesMsg = h('p', { class: ['text-left', 'y-16'] }, [
        this.t('vehicle.crud.assignBusy', { plate: vehicleTemp.plate }),
      ]);

      const $vNodesTitle = h('div', { class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'] }, [
        h('strong', { class: 'mr-2-xl' }, 'Confirmación'),
      ]);

      this.$bvToast.toast([$vNodesMsg, $closeButton, $acceptButton], {
        id: id,
        title: [$vNodesTitle],
        variant: 'alert',
        toaster: 'b-toaster-top-center',
        noCloseButton: true,
        static: true,
        noAutoHide: true,
        solid: true,
      });
    },
    closeExcel() {
      this.$bvModal.hide('crud-vehicle-modal');
    },
    async validateDateRequiredExcel(
      row,
      index,
      listIndexPlate,
      listIndexType,
      listPlateMaxOut,
      listBrandNotExist,
      listEnabledEmpty,
    ) {
      let vehicleProblem = null;
      if (row.typeExtra == null || row.typeExtra == undefined || row.typeExtra == '') {
        listIndexPlate.push(index + 1);
        vehicleProblem = {
          status: 'FAIL',
          message: 'Tipo de vehículo en fila ' + listIndexPlate.toString() + ' es obligatorio',
        };
      }
      if (row.available == null || row.available == undefined || row.available == '') {
        listEnabledEmpty.push(index + 1);
        vehicleProblem = {
          status: 'FAIL',
          message: 'El campo de habilitar/deshabilitar en fila ' + listEnabledEmpty.toString() + ' es obligatorio',
        };
      }
      if (row.plate == null || row.plate == undefined || row.plate == '') {
        listIndexType.push(index + 1);
        vehicleProblem = {
          status: 'FAIL',
          message: 'Patente en fila ' + listIndexType.toString() + ' es obligatorio',
        };
      }
      if (vehicleProblem == null && row.plate.length > 20) {
        listPlateMaxOut.push(row.plate);
        vehicleProblem = {
          status: 'FAIL',
          message: 'Patente: ' + listPlateMaxOut.toString() + ' no puede poseer mas de 20 caracteres',
        };
      }
      if (vehicleProblem == null && row.brand != null && row.brand != undefined) {
        const brand = this.dataBrand.find((brand) => row.brand.trim().toLowerCase() === brand.trim().toLowerCase());
        if (!brand) {
          listBrandNotExist.push(row.brand);
          vehicleProblem = {
            status: 'FAIL',
            message: 'Marca: ' + listBrandNotExist.toString() + ' no corresponde a alguna de las marcas registradas',
          };
        }
      }
      if (vehicleProblem == null && row.tag != null && row.tag != undefined && row.tag != '') {
        const tagsWProblem = await this.validateTags(row.tag);
        if (tagsWProblem != null) {
          const textResult = await this.arrayToText(tagsWProblem);
          vehicleProblem = {
            status: 'FAIL',
            message:
              'Atributos: [' +
              textResult +
              '] en fila ' +
              (index + 2) +
              ' no corresponde a alguna de las marcas registradas',
          };
        }
      }
      return vehicleProblem;
    },
    async arrayToText(array) {
      let text = '';
      for (let tagSplitted of array) {
        text += tagSplitted + ', ';
      }
      return text.length >= 2 ? text.slice(0, -2) : text;
    },
    async validateTags(tags) {
      if (!tags || typeof tags !== 'string') {
        return null; // Maneja casos de entrada no válida
      }

      const tagsSplitted = tags.includes(',') ? tags.split(',') : [tags]; // Normaliza el formato
      const unmatchedTags = [];

      for (let tagSplitted of tagsSplitted) {
        const isMatched = this.tags.some((tagData) => tagData.name === tagSplitted); // Verifica si existe
        if (!isMatched) {
          unmatchedTags.push(tagSplitted);
        }
      }

      return unmatchedTags.length == 0 ? null : unmatchedTags;
    },
  },
};
